import React from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import './style.css'


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root : {
        marginTop : theme.spacing(2),
        color : "#d50000"
    }
  }),
);

export default function RecordingIndicator() {
    const classes = useStyles()
    return (
        <div className="container">
            <div className="ring-container">
              <div className="circle"></div>
              <div className="pulse"></div>
            </div>
            <p className={classes.root}>Recording</p>
        </div>
    )
}